import React from "react";
import { Helmet } from "react-helmet-async";

const CourseSEO = ({
  title = "Studyhub",
  description = "Best platform to learn new skills online",
  keywords = [],
  image = "/default-image.png",
  url = "",
  type = "website",
  author = "Studyhub",
  structuredData = null,
}) => {
  const siteUrl = "https://www.studyhub.lk";

  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const metaKeywords =
    keywords.length > 0 ? keywords.join(", ") : "online courses, learning";

  return (
    <Helmet>
      {/* Basic SEO */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={metaKeywords} />
      <meta name="author" content={author} />

      {/* Open Graph (Facebook, LinkedIn, WhatsApp) */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={fullUrl} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />

      {/* Structured Data (JSON-LD) */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default CourseSEO;